
import { BookingLogEntry } from '@/api/dtos/LogEntry.schema'
import { rentalStatusToGerman } from '@/misc/i18n'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BookingLogEntryContent extends Vue {
  @Prop()
  logEntry!: BookingLogEntry

  rentalStatusToGerman = rentalStatusToGerman
}
